module.exports = __webpack_public_path__ + "img/farewell_12.e4a888f8.jpg";